import * as React from "react";
import {Component, ReactNode} from "react";
import {Button} from "reactstrap";
import "./SubscriptionForm.css";
import {InjectedFormProps, reduxForm} from 'redux-form';
import ISubscriptionData from "../forms/ISubscriptionData";
import LandingPageConfig from "../objects/LandingPageConfig";
import {FormattedMessage} from 'react-intl';
import TextInput from "../../shared/forms/inputs/TextInput";

export const FIELD_OTP = "otp";

interface ISubscription2FAFormWithFormProps extends ISubscriptionFormProps,
    InjectedFormProps<ISubscriptionData, ISubscriptionFormProps> {
}

class Subscription2FAFormInner extends Component<ISubscription2FAFormWithFormProps> {

    public render(): ReactNode {
        const { invalid, submitting, handleSubmit, onSubmit} = this.props;
        return (
            <form className="subscription-form" onSubmit={handleSubmit(onSubmit)}>
                <p><FormattedMessage id="landing.subscription.2fa.description" /></p>

                <div className="subscription-form-fields">

                    <TextInput inputID={FIELD_OTP}
                               label={<FormattedMessage id="landing.subscription.field.otp"/>}
                    />

                </div>

                <p>
                    <Button color="primary" disabled={invalid || submitting}>
                        <FormattedMessage id="landing.subscription.button.sign_up"/>
                    </Button>
                </p>
            </form>
        );
    }
}

export interface ISubscriptionFormProps {
    landingPageConfig: LandingPageConfig;
    onSubmit: (formData: ISubscriptionData) => Promise<void>;
}

export default reduxForm<ISubscriptionData, ISubscriptionFormProps>(
    {form: "Subscription2FAForm"}
)(Subscription2FAFormInner)